import { Component, Input } from '@angular/core';
import { Customer } from '../../../models/customer/customer';
import { PaymentMethod } from '../../../models/paymentMethod/paymentMethod';
import { MatTableDataSource } from '@angular/material/table';
import { Formatters } from '../../../models/ui/formatters';
import { Logging } from '../../../core/logging';

@Component({
  selector: 'app-customer-details',
  templateUrl: './customer-details.component.html',
  standalone: false,
})
export class CustomerDetailsComponent {
  formatPhoneNumber = Formatters.formatPhoneNumber;

  @Input() customer: Partial<Customer>;

  tabbed: boolean = true;

  paymentMethodsDataSource: MatTableDataSource<PaymentMethod> =
    new MatTableDataSource();
  displayedPaymentColumns: string[] = ['name', 'expires', 'use'];

  constructor() {
    this.customer = Customer.createEmpty();

    Formatters.formatPhoneNumber('');
  }

  ngOnInit() {
    this.selectBookmark('customerInformationContainer');
  }

  selectBookmark(selector: string) {
    // hide all tabs
    let tabs = document.getElementsByClassName('content selected');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove('selected');
    }

    let tabContents = document.getElementsByClassName('tabContent selected');
    for (var i = 0; i < tabContents.length; i++) {
      tabContents[i].classList.remove('selected');
    }

    let selectedTab = document.getElementById('tab_' + selector);
    selectedTab?.children[0].classList.add('selected');

    let selectedTabContent = document.getElementById(selector);

    selectedTabContent?.classList.add('selected');
    //scrollToTop(selector, this.scrollToYoffset);
  }
}
